import e from"react";import o from"react-dom/client";import t from"./canvas/workspace.js";import r from"./toolbar/toolbar.js";import n,{DEFAULT_SECTIONS as s}from"./side-panel/side-panel.js";import i from"./toolbar/zoom-buttons.js";import{DownloadButton as a}from"./toolbar/download-button.js";import l from"./utils/styled.js";import{mobileStyle as c}from"./utils/screen.js";import{createStore as p}from"./model/store.js";export const PolotnoContainer=l("div")`
  display: flex;
  height: 100%;
  width: 100%;
  max-height: 100vh;

  ${c("\n    flex-direction: column-reverse;\n  ")}
`;export const SidePanelWrap=l("div")`
  height: 100%;
  width: auto;
  max-height: 100vh;

  ${c("\n    height: auto;\n    width: 100vw;\n  ")}
`;export const WorkspaceWrap=l("div")`
  display: flex;
  height: 100%;
  width: 100%;
  flex: 1;
  flex-direction: column;
  position: relative;
`;export const PolotnoApp=({store:o,style:l,sections:c})=>{let p=s;return c&&(p=c.map(e=>{const o=s.find(o=>o.name===e);return o||console.error(`Section ${e} not found`),o}).filter(Boolean)),e.createElement(PolotnoContainer,{className:"polotno-app-container",style:l},e.createElement(SidePanelWrap,null,e.createElement(n,{store:o,sections:p})),e.createElement(WorkspaceWrap,null,e.createElement(r,{store:o,components:{ActionControls:()=>e.createElement(a,{store:o})}}),e.createElement(t,{store:o}),e.createElement(i,{store:o})))};export function createPolotnoApp({container:t,key:r,showCredit:n,sections:s}){const i=p({key:r,showCredit:n}),a=o.createRoot(t);return a.render(e.createElement(PolotnoApp,{store:i,sections:s})),i.addPage(),i.history.clear(),{store:i,root:a}}export const createDemoApp=createPolotnoApp;